import styles from './index.module.less'
import Title from '@/components/BlockTitleTwo'
import BlockTitle from '@/components/BockTitle'
import SearchInput from '@/components/SearchInputTwo'
import icon from '@/assets/image/gea/verifynodes.svg'
import InfoCard from './components/detailCard'
import ReactJson from 'react-json-view'
import SlideBtn, { type IbtnListItem } from '@/components/SlideBtn'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  getRestBlockDetail,
  getRestBlockModuleTransfers,
  getRestBlockRawLog,
  getRestBlockTxs,
} from '@/api/blocks'
import { useParams } from 'react-router-dom'
import {
  BlockDetailItem,
  ModuleTransfer,
  ResponseData,
  TransactionDataList,
  TransactionList,
} from '@/api/blocks/interface'
import ModuleAccountTradingList from './components/moduleAccountTradingList'
import TransactionCardList from './components/transactionCardList'
import { useRequest } from 'ahooks'
import MePagination from '@/components/MePagination'
import LoadingCom from '@/components/LoadingCom'
const Index = () => {
  const { t } = useTranslation()
  const params = useParams()
  // 系统账户交易分页
  const [pageParams, setPageParams] = useState<{
    offset: number
    limit: number
    page: number
  }>({
    offset: 0,
    limit: 10,
    page: 1,
  })

  // 交易分页
  const [normalPageParams, setNormalPageParams] = useState<{
    offset: number
    limit: number
    page: number
  }>({
    offset: 0,
    limit: 10,
    page: 1,
  })
  const [btnList, setBtnList] = useState<IbtnListItem[]>([
    {
      // 交易
      name: t('explorer_4'),
      value: '0',
      active: true,
    },
    {
      // 系统账户交易
      name: t('explorer_102'),
      value: '1',
      active: false,
    },
  ])
  const [docBtnList, setDocBtnList] = useState<IbtnListItem[]>([
    {
      // 概述
      name: t('explorer_97'),
      value: '0',
      active: true,
    },
    {
      // 日志
      name: t('explorer_98'),
      value: '1',
      active: false,
    },
  ])

  const [blockDetail, setBlockDetail] = useState<BlockDetailItem>({} as BlockDetailItem)
  const [blockTxs, setBlockTxs] = useState<TransactionList[]>([] as TransactionList[])
  const [blockTxsTotal, setBlockTxsTotal] = useState<number>(0)
  const [moduleTransfers, setModuleTransfers] = useState<ModuleTransfer[]>([] as ModuleTransfer[])
  const [moduleTransfersTotal, setModuleTransfersTotal] = useState<number>(0)
  const [rawLog, setRawLog] = useState<{ [key: string]: any } | null>(null)
  const [rawLogLoad, setRawLogLoad] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)

  /**
   * 获取区块详情
   */
  const getRestBlockDetailFn = async (height: number) => {
    setLoading(true)
    const res = await getRestBlockDetail({ height })
    if (res?.block?.length) {
      setBlockDetail(res.block[0])
    }
    setLoading(false)
  }

  const getRestBlockRawLogFn = async (height: number) => {
    const res = await getRestBlockRawLog({ height })
    setRawLog(res)
    setRawLogLoad(true)
  }

  useEffect(() => {
    getRestBlockDetailFn(Number(params.dynamic))
  }, [params.dynamic])

  /**
   * 获取区块交易列表
   */
  const { loading: loadingTxs } = useRequest(
    () =>
      getRestBlockTxs({
        ...normalPageParams,
        height: Number(params.dynamic),
      }),
    {
      refreshDeps: [normalPageParams],
      ready: !!params.dynamic,
      onSuccess: (res: TransactionDataList) => {
        if (res?.txs) {
          setBlockTxs(res.txs)
          setBlockTxsTotal(res.count?.aggregate?.count)
        }
      },
    },
  )

  const { loading: loadingModuleTransfers } = useRequest(
    () =>
      getRestBlockModuleTransfers({
        offset: pageParams.offset,
        limit: pageParams.limit,
        height: Number(params.dynamic),
      }),
    {
      refreshDeps: [pageParams],
      ready: !!params.dynamic,
      onSuccess: (res: ResponseData) => {
        if (res) {
          setModuleTransfersTotal(res.data[0].count)
          setModuleTransfers(res.data[0].transfers)
        }
      },
    },
  )

  useEffect(() => {
    if (docBtnList[1].active && !rawLogLoad) {
      getRestBlockRawLogFn(Number(params.dynamic))
    }
  }, [docBtnList])

  return (
    <div className={styles.wrap} key={params.dynamic}>
      <div className={styles.titleWrap}>
        {/* 区块详情 */}
        {/* icon={icon} */}
        <Title title={t('explorer_96')} />
        <div className="search_input">
          <SearchInput placeholder={t('explorer_8')} />
        </div>
      </div>
      <div className={styles.BlockTitleWrap}>
        <BlockTitle title={`#${params.dynamic} ${t('explorer_3')}`}></BlockTitle>
        {!loading && (
          <SlideBtn btnList={docBtnList} setBtnList={setDocBtnList} renderKey={params.dynamic} />
        )}
      </div>
      <div className={styles.infoCard}>
        {docBtnList[0].active ? (
          <InfoCard loading={loading} blockDetail={blockDetail}></InfoCard>
        ) : null}
        {docBtnList[1].active ? (
          <div className={'globalJsonWrap'}>
            {rawLogLoad ? (
              <ReactJson
                collapsed={4}
                displayObjectSize={false}
                src={rawLog || {}}
                iconStyle={'triangle'}
                theme={'apathy'}
                displayDataTypes={false}
              />
            ) : (
              <div className={'loadingWrap'}>
                <LoadingCom></LoadingCom>
              </div>
            )}
          </div>
        ) : null}
      </div>
      <div className={styles.slideBtn}>
        <SlideBtn btnList={btnList} setBtnList={setBtnList} />
        <div className="gea_pagination_box  gea_pagination_wrap">
          {btnList[0].active ? (
            <MePagination
              currentPage={normalPageParams.page}
              pageSize={normalPageParams.limit}
              total={blockTxsTotal}
              loading={loadingModuleTransfers}
              setPageParams={setNormalPageParams}
            ></MePagination>
          ) : null}
          {btnList[1].active ? (
            <MePagination
              currentPage={pageParams.page}
              pageSize={pageParams.limit}
              total={moduleTransfersTotal}
              loading={loadingModuleTransfers}
              setPageParams={setPageParams}
            ></MePagination>
          ) : null}
        </div>
      </div>
      <div className={styles.transactionCardWrap}>
        <div
          style={{
            display: btnList[0].active ? 'block' : 'none',
          }}
        >
          <TransactionCardList blockTxs={blockTxs} loading={loadingTxs}></TransactionCardList>
        </div>
        <div
          style={{
            display: btnList[1].active ? 'block' : 'none',
          }}
        >
          <ModuleAccountTradingList
            moduleTransfers={moduleTransfers}
            loading={loadingModuleTransfers}
          ></ModuleAccountTradingList>
        </div>
      </div>
      <div className="footer_pagination">
        {btnList[0].active ? (
          <MePagination
            currentPage={normalPageParams.page}
            pageSize={normalPageParams.limit}
            total={blockTxsTotal}
            loading={loadingModuleTransfers}
            setPageParams={setNormalPageParams}
          ></MePagination>
        ) : null}
        {btnList[1].active ? (
          <MePagination
            currentPage={pageParams.page}
            pageSize={pageParams.limit}
            total={moduleTransfersTotal}
            loading={loadingModuleTransfers}
            setPageParams={setPageParams}
          ></MePagination>
        ) : null}
      </div>
    </div>
  )
}

export default Index
